
import apiClient from '../helpers/apiClient';
import { authHeader } from '../helpers/authHeader';


export const priceService = {
     getPriceList,
     getPriceDetails,
     updateSingleItem,
     updateStatus
    
};





async function  getPriceList() {
    return  apiClient.get(`/inventory/price-list`, authHeader());
}

async function  getPriceDetails(id, product_id) {
    return  apiClient.get(`/inventory/price-details/${id}/${product_id}`, authHeader());
}
async function  updateSingleItem(data) {
    return  apiClient.put(`/inventory/update-single-item`, data, authHeader());
}


async function  updateStatus(data) {
    return  apiClient.put(`/inventory/update-single-status`, data, authHeader());
}









